import { isObjectDeeplyChanged } from '../../util/state';
import { State } from '../App/selector';

/**
 * Update flags for Discount section
 */
export const getUpdateFlags = (state: State, oldState: State) => {
    const {
        isGigakombi,
        selectedTariffId,
        isYoung,
        isTVProductSelected,
        isAvailabilityChecked,
        selectedTVProduct,
    } = state;
    const isGigakombiChanged = isGigakombi !== oldState.isGigakombi;
    const isSelectedChanged = selectedTariffId !== oldState.selectedTariffId;
    const isTVProductSelectionChanged = isTVProductSelected !== oldState.isTVProductSelected;
    const isYoungChanged = isYoung !== oldState.isYoung;
    const isAvailabilityChanged = isAvailabilityChecked !== oldState.isAvailabilityChecked;
    const isSelectedTVProductChanged = isObjectDeeplyChanged(selectedTVProduct, oldState.selectedTVProduct);

    return {
        legalOverlayButtons: isSelectedChanged || isGigakombiChanged || isTVProductSelectionChanged || isYoungChanged,
        tvConnect: isAvailabilityChanged || isSelectedTVProductChanged,
    };
};
